import { useNavigate } from 'react-router';
import routes from '../../routing/routes';

export type IntroPageViewModel = ReturnType<typeof useIntroPageViewModel>;
export function useIntroPageViewModel() {
  const navigate = useNavigate();

  const gotToNextStep = () => {
    return navigate(routes.createWizardCategoryUrl());
  };

  return {
    gotToNextStep,
  };
};
